import React from 'react';
import { Form, Input } from 'antd';
import valid from 'card-validator';
import InputMask from 'react-input-mask';
import useElements from '../../hooks/useElements';

const elementType = 'expiry';
function CardExpiryElement({ onChange, defaultValue, placeholder = 'Data de validade' }) {
  const form = Form.useFormInstance();
  const [_, setElements] = useElements();

  return (
    <Form.Item 
      name={elementType}
      label={placeholder}
      initialValue={defaultValue}
      rules={[
        { required: true, message: `${placeholder} é obrigatório.`, },
        { min: 5, message: `${placeholder} deve conter no mínimo 4 caracteres.` },
        { 
          validator: (_, original_value) => {
            const value = (original_value || '').replace(/[ ,D,_]/gi, '');
            const validation = valid.expirationDate(value);
            const { isValid } = validation || {};
            return isValid ? Promise.resolve() : Promise.reject(new Error('Should accept agreement'))
          },
          message: `${placeholder} não é válido.`
        },
      ]}
    >
      <InputMask
        mask="99/99"
        maskChar="_"
        onChange={(event) => {  
          if (!onChange) return;
          setTimeout(() => {
            const errors = form.getFieldError(elementType);
            const value = (event?.target?.value || '').replace(/[ ,D,_,/]/gi, '');

            const payload = {
              elementType,
              complete: errors.length <= 0,             
              exp_month: value ? value.substring(0, 2) : null,
              exp_year: value ? `20${value.substring(2)}` : null,
              errors,
            };
            setElements((oldState) => ({ ...oldState, [elementType]: payload }));
            onChange(payload);  
          }, 1);
        }}
      >
        {() => (
          <Input 
            id={`${elementType}-input`}
            placeholder={placeholder}  
            size="large"
          />
        )}
      </InputMask>
    </Form.Item>
  )
};

export default CardExpiryElement;